// extracted by mini-css-extract-plugin
var _1 = "U_EFnCrytzro_fwhUjVf";
export { _1 as "altSkuField" }
export default { "altSkuField": _1 }
